/**
 * @generated SignedSource<<98f25a77b040f6bab5774eb6c21d29d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgStoreAdminArchiveStoreMutation$variables = {
  storeId: string;
};
export type OrgStoreAdminArchiveStoreMutation$data = {
  readonly organisation: {
    readonly archiveStore: {
      readonly storeId: string;
    };
  };
};
export type OrgStoreAdminArchiveStoreMutation = {
  response: OrgStoreAdminArchiveStoreMutation$data;
  variables: OrgStoreAdminArchiveStoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "storeId",
            "variableName": "storeId"
          }
        ],
        "concreteType": "OrgStoreArchivePayload",
        "kind": "LinkedField",
        "name": "archiveStore",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "storeId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgStoreAdminArchiveStoreMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgStoreAdminArchiveStoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7df3d60a0bdbf99731a1d7117012b502",
    "id": null,
    "metadata": {},
    "name": "OrgStoreAdminArchiveStoreMutation",
    "operationKind": "mutation",
    "text": "mutation OrgStoreAdminArchiveStoreMutation(\n  $storeId: ID!\n) {\n  organisation {\n    archiveStore(storeId: $storeId) {\n      storeId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b6be79ea02bc2c6aa0d1f05f1d635909";

export default node;
